import { createTheme } from '@mui/material';
import { deepmerge } from '@mui/utils';
import { defaultVillageUiTheme } from '@village/ui';

export const villageMdTheme = deepmerge(
    defaultVillageUiTheme,
    createTheme({
        vui: {
            platform: 'web',
            component: {
                buttonCard: {
                    default: {
                        borderRadius: '8px',
                    },
                    hover: {
                        borderColor: '#DCEAEF',
                        borderRadius: '8px',
                        contentColor: '#2C3542',
                    },
                    selected: {
                        borderRadius: '8px',
                    },
                },
                input: {
                    default: {
                        default: {
                            textColor: '#2C3542',
                        },
                    },
                },
                autocomplete: {
                    default: {
                        textColor: '#2C3542',
                    },
                },
                tag: {
                    default: {
                        backgroundColor: '#DCEAEF',
                    },
                },
            },
            colors: {
                text: {
                    grayDefault: '#2C3542',
                    grayMuted: '#4C535E',
                    secondary: '#565d68',
                    slate600: '#626a74',
                    brand: {
                        default: '#2355EC',
                    },
                    critical: {
                        default: '#D80032',
                    },
                    link: {
                        default: '#2355EC',
                        secondary: {
                            default: '#D80032',
                        },
                    },
                },
                icon: {
                    default: '#2C3542',
                    critical: '#D80032',
                },
                border: {
                    tertiary: {
                        default: '#DCEAEF',
                        hover: '#C4E1E7',
                        active: '#A7D6E1',
                    },
                },
                background: {
                    surface: {
                        default: '#FFFFFF',
                        secondary: {
                            default: '#F5F8FA',
                        },
                        critical: {
                            default: '#FDEBEB',
                        },
                    },
                },
            },
        },
    })
);
